import { APP_STARTED, REQUEST_EDITOR_TOUR, UPDATE_PATH_PARAMS } from './ActionTypes';
import { fetchTemplates } from './TemplateActions';
import router from 'web-interactives-dashboard-ui/history';
export const startApp = () => ({
  type: APP_STARTED
});
export const updatePathParams = pathParams => ({
  type: UPDATE_PATH_PARAMS,
  pathParams
});
export const requestEditorTour = () => ({
  type: REQUEST_EDITOR_TOUR
});
export const updatePathParamsAndLocation = pathParams => dispatch => {
  dispatch(updatePathParams(pathParams));
  router.navigateTo(`/${pathParams.join('/')}`, window.location.search);
};
export const startAppAndFetch = () => dispatch => {
  dispatch({
    type: APP_STARTED
  });
  dispatch(fetchTemplates());
};